import React from "react";
import TextField from "@mui/material/TextField";

export default function TextInput(props) {
  const { label, text, setText, required } = props;
  return (
    <TextField
      required={required}
      id="outlined-basic"
      variant="outlined"
      label={label}
      value={text}
      onChange={(event) => {
        setText(event.target.value);
      }}
      style={{
        flexGrow: "1",
        maxWidth: "250px",
        backgroundColor: "white",
      }}
    />
  );
}
